import { createSelector } from '@reduxjs/toolkit';
import type { CategoryModel } from './types';
import type { RootState } from '../store';

const selectState = (state: RootState): RootState['categories'] => state.categories;

export const selectCategoryById = createSelector(
    [
        selectState,
        (state: RootState, categoryId: CategoryModel['id']): CategoryModel['id'] => categoryId,
    ],
    (draft, postId) => draft.records[postId],
);

export const selectCategoryCollection = createSelector(
    [(state) => state, (state: RootState, namespace: string): string => namespace],
    (draft, namepsace) => {
        const identifiers = draft.categories.collections[namepsace]?.identifiers ?? [];

        return identifiers
            .map((id: string) => selectCategoryById(draft, id))
            .filter(Boolean) as CategoryModel[];
    },
);

export const selectCategoryCollectionLoading = createSelector(
    [selectState, (state: RootState, namespace: string): string => namespace],
    (draft, namespace): boolean => draft.collections[namespace]?.isLoading ?? false,
);
